import React from 'react'
import { Link } from 'react-router-dom'
import InstallGuide from './InstallGuide'

const isWeiXin = () => window.navigator.userAgent.toLowerCase().includes('micromessenger')

const Install = () => {
  if (isWeiXin()) {
    return (
      <div className='max-w-lg mx-auto mt-10 rounded-3xl border border-slate-200 bg-white shadow-soft p-8 text-center text-slate-700'>
        请点击右上角按钮，选择“在默认浏览器中打开”。
      </div>
    )
  }

  return (
    <div className='text-view pt-running-text'>
      <ul className='pt-breadcrumbs'>
        <li><Link className='pt-breadcrumb' to='/'>Home</Link></li>
        <li><span className='pt-breadcrumb pt-breadcrumb-current'>Surge Enterprise Install Guide</span></li>
      </ul>
      <InstallGuide />
    </div>
  )
}

export default Install
